import { render, staticRenderFns } from "./chooseBoth.vue?vue&type=template&id=56f1a570&scoped=true&"
import script from "./chooseBoth.vue?vue&type=script&lang=js&"
export * from "./chooseBoth.vue?vue&type=script&lang=js&"
import style0 from "./chooseBoth.vue?vue&type=style&index=0&id=56f1a570&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f1a570",
  null
  
)

export default component.exports